import React from 'react';
import cn from 'classnames';
import { Typography } from 'seagull';
import { CopyToClipboard } from "../../components/CopyToClipboard/CopyToClipboard";
import styles from "./CopyLinkForProposalModal.module.scss";
export function CopyLinkForProposalModal(props) {
  const {
    className,
    onClick,
    onError,
    onCopy,
    recipients
  } = props;
  const dataTestId = props['data-testid'] || 'copy-to-clipboard';
  const Recipient = _ref => {
    let {
      index,
      recipient: {
        firstName,
        lastName,
        email,
        notificationId
      }
    } = _ref;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles.linkRow
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.reviewerDetails
    }, /*#__PURE__*/React.createElement(Typography, {
      ellipsis: true,
      variant: 'paragraph1',
      weight: 'normal',
      "data-testid": 'recipient-name'
    }, "".concat(firstName, " ").concat(lastName)), /*#__PURE__*/React.createElement(Typography, {
      ellipsis: true,
      variant: 'paragraph2',
      weight: 'light',
      "data-testid": 'recipient-email'
    }, email)), /*#__PURE__*/React.createElement(CopyToClipboard, {
      value: notificationId,
      buttonLabel: 'Copy',
      onClick: onClick,
      onError: onError,
      onCopy: onCopy,
      buttonClassname: styles.button,
      textfieldClassname: styles.link
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.multipleRecipientsRoot, className),
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.title
  }, "Links are unique per recipient. Make sure that each link is sent to the intended recipient."), /*#__PURE__*/React.createElement("div", {
    className: styles.linksContainer
  }, recipients.map((recipient, index) => /*#__PURE__*/React.createElement(Recipient, {
    recipient: recipient,
    index: index,
    key: recipient.notificationId
  }))));
}